import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ProfileService } from '../profile/profile.service';
import { PROFILE_STAGES } from '../profile/types/profile-stages.model';
import { ProfileTracker, PROFILE_TRACKER_STAGE_STATUS } from '../profile/types/profile-tracker.model';
import { AuthService } from './auth.service';
import { sanitizePostLoginRedirectParam } from '../shared/membership/membership-access';

@Injectable()
export class AuthGuardService implements CanActivate {
    constructor(public auth: AuthService, public router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const url = state.url;
        const safeReturn = sanitizePostLoginRedirectParam(url);
        this.auth.redirectUrl = safeReturn ?? '';
        if (!this.auth.isAuthenticated()) {
            this.router.navigate(['/login'], {
                queryParams: safeReturn ? { redirecturl: safeReturn } : {},
            });
            return false;
        }
        return true;
    }
}